export const AvenuName = require("../../assets/images/avenunamegreen.png");
export const AvenuNameOld = require("../../assets/images/avenunameold.png");
export const AvenuArrow = require("../../assets/images/avenu-arrow.png");
export const AvenuNameNew = require("../../assets/images/avenunamenew.png");